import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, Col, Dropdown, Form, Row, Table } from "react-bootstrap";

export default function Offal({
  body,
  selectedSpecies,
  items,
  loading,
  handleChange,
  handleOriginChange,
  handleSubmit,
  existingTypes,
  setExistingTypes,
  setBody,
}) {
  const [filteredTypes, setFilteredTypes] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [showCreateButton, setShowCreateButton] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  useEffect(() => {
    setFilteredTypes(existingTypes);
  }, [existingTypes]);

  const handleTypeChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setBody({ ...body, type: value });
    // Filter the existing types based on the input
    const filtered = existingTypes.filter((type) =>
      type.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredTypes(filtered);
    let showButton = filtered.length === 0 && value !== "";
    // Show the create button if no matching types
    setShowCreateButton(showButton);
    // Control dropdown visibility
    setDropdownVisible(filtered.length > 0 || showButton);
  };

  const handleCreateType = () => {
    setFilteredTypes([inputValue, ...filteredTypes]);
    setExistingTypes([inputValue, ...existingTypes]);
    setInputValue(inputValue); // Reset input after creation
    setBody({ ...body, type: inputValue });
    setShowCreateButton(false); // Hide the create button
    setDropdownVisible(false); // Hide the dropdown after creation
  };
  const handleTypeSelect = (type) => {
    setInputValue(type);
    setDropdownVisible(false);
    setBody({ ...body, type });
  };

  const handleBlur = () => {
    setTimeout(() => setDropdownVisible(false), 100); // Delay to allow item click
  };
  const handleWeightChange = (e) => {
    const value = e.target.value;

    // Regular expression to allow only positive numbers (integer or decimal)
    const regex = /^\d*\.?\d*$/;

    if (regex.test(value)) {
      handleChange(e); // Only update the state if the value is valid
    }
  };

  if (!filteredTypes) {
    return (
      <div className="d-flex justify-content-center align-items-center mt-5">
        <CircularProgress variant="determinate" value={50} valueBuffer={20} />
      </div>
    );
  }
  return (
    <>
      <Row className="">
        <Col xs={12} xl={6}>
          <Form.Group>
            <Form.Label>Owner</Form.Label>
            <Form.Control
              type="text"
              onChange={handleChange}
              value={body.customer}
              id="customer"
              name="customer"
            />
          </Form.Group>
        </Col>
        <Col xs={12} xl={6}>
          <Form.Group>
            <Form.Label>Type</Form.Label>
            <Dropdown show={dropdownVisible}>
              <Dropdown.Toggle
                as={Form.Control}
                type="text"
                onChange={handleTypeChange}
                value={body.type}
                id="type"
                name="type"
                onFocus={() => setDropdownVisible(true)}
                onClick={() => setDropdownVisible(true)}
                onBlur={handleBlur}
              />

              <Dropdown.Menu>
                {filteredTypes.length > 0
                  ? filteredTypes.map((type, index) => (
                      <Dropdown.Item
                        key={index}
                        onClick={() => handleTypeSelect(type)}>
                        {type}
                      </Dropdown.Item>
                    ))
                  : !showCreateButton && (
                      <div className="d-flex justify-content-center align-items-center">
                        {" "}
                        No data found
                      </div>
                    )}
                {showCreateButton && (
                  <Dropdown.Item as="button" onClick={handleCreateType}>
                    Create
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} xl={3}>
          <Form.Group>
            <Form.Label>Weight</Form.Label>
            <Form.Control
              type="text"
              onChange={handleWeightChange}
              value={body.weight}
              id="weight"
              name="weight"
              className="w-100"
            />
          </Form.Group>
        </Col>
        <Col xs={0} xl={3}></Col>
        <Col
          md={12}
          xl={6}
          className="d-md-flex justify-content-xl-end mt-xl-3">
          <Col xs={12} md={6} xl={3} className="pe-2">
            <Button variant="primary" className="w-100" onClick={handleSubmit}>
              Add Item
            </Button>
          </Col>
          <Col xs={12} md={6} xl={3} className="pe-2">
            <Button variant="primary" className="w-100">
              Print
            </Button>
          </Col>
        </Col>
      </Row>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center mt-5">
          <CircularProgress variant="determinate" value={50} valueBuffer={20} />
        </div>
      ) : (
        <div
          className="table-container table-responsive"
          style={{
            maxHeight: "500px",
            overflow: "auto",
            backgroundColor: "#eee",
          }}>
          {body.production_date ? (
            items.length > 0 ? (
              <Table striped bordered hover className="">
                <thead>
                  <tr>
                    <th>Transaction Id</th>
                    <th>Customer</th>
                    <th>Type</th>
                    <th>Weight</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item) => (
                    <tr>
                      <td>{item.transaction_id}</td>
                      <td>{item.customer}</td>
                      <td>{item.type}</td>
                      <td>{item.weight}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div className="text-center fs-5 py-2">No Items found</div>
            )
          ) : (
            <div className="text-center fs-5 py-2">
              {" "}
              Select date to get items
            </div>
          )}
        </div>
      )}
    </>
  );
}
